<div class="container-fluid">
  <div class="row" *ngIf="!presentation">
    <div class="col-3">
      <menu></menu>
    </div>
    <div class="col-9">
      <div class="presenter_content justified" style="margin:20px" [innerHTML]="welcome.content"></div>
    </div>
  </div>
  <div class="row" *ngIf="presentation">
    <div class="col-12">
      <presentation [key]="presentation"></presentation>
    </div>
  </div>
</div>




